<template>
  <div class="appointment_main">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <el-date-picker
          v-model="timeValue"
          type="daterange"
          :picker-options="pickerOptions2"
          size="small"
          unlink-panels
          @change="changeTimeValue"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
        <button-add :value="'添加'" @click="toAddPage" style="margin-left: 10px;" v-if="permissionCodes.indexOf('017004001') !== -1"/>
        <button-delete @deleteSelection="deleteSelection" :value="'删除'" v-if="permissionCodes.indexOf('017004002') !== -1"/>
      </div>
      <input-search placeholder="房间号" @search="searchKey" />
    </div>

    <table-main :tableHead="tableHead" @changeSelection="changeSelection" @deleteLine="deleteLine" :tableData="tableData" :deleteTipInfo="'是否确认删除该记录？'" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :operationArr="operationArr" />
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import InputSearch from '../../../components/Input/InputSearch'
  import TableMain from '../../../components/Table/TableMain'
  import {api} from '../../api/agent'
  import {errorHandler} from '../../../utils/errorHandler'
  import ButtonConfirmNext from '../../../components/Button/ButtonConfirmNext'
  import {nAlert, nSuccess} from '../../../utils/notice'
  import ButtonAdd from '../../../components/common/buttons/button-add'
  import ButtonDelete from '../../../components/Button/ButtonDelete'
  import {bus} from '../../../utils/bus'

  export default {
    components: {
      ButtonAdd,
      ButtonDelete,
      ButtonConfirmNext,
      TableMain,
      InputSearch,
      Breadcrumb},
    name: 'agent-showing',
    data () {
      return {
        permissionCodes: '',
        breadcrumb: [{
          value: '智慧经纪',
          name: 'investment-manage'
        }, {
          value: '看房记录'
        }],
        pickerOptions2: {
          disabledDate (time) {
            return time.getTime() > new Date(((new Date) / 1000 + 86400) * 1000)
          },
          shortcuts: [{
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }]
        },
        tableHead: [{
          prop: 'roomNumber',
          label: '房间号'
        }, {
          prop: 'roomArea',
          label: '房源面积(m²)'
        }, {
          prop: 'fitmentText',
          label: '装修'
        }, {
          prop: 'roomRent',
          label: '预租单价(元/m²/天)'
        }, {
          prop: 'personName',
          label: '经纪人姓名'
        }, {
          prop: 'showRoomResults',
          label: '看房结果'
        }, {
          prop: 'showRoomTime',
          label: '看房时间'
        }],
        tableData: [],
        operationArr: ['delete'],
        total: 0,
        pageSize: 10,
        pageNum: 1,
        timeValue: [],
        requestData: {
          pageNum: 1,
          pageSize: 10,
          startTime: '',
          endTime: '',
          searchKey: ''
        },

        selectionArr: [],
      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes
      this.getCreatTime()
    },
    activated() {
      this.getPage()
    },
    methods: {
      toAddPage () {
        this.$router.push({
          name: 'agent-showing-add'
        })
      },
      getCreatTime () {
        let nowDate = new Date
        let year = nowDate.getFullYear()
        let month = (nowDate.getMonth() + 1) < 10 ? '0' + (nowDate.getMonth() + 1) : (nowDate.getMonth() + 1)
        let date = nowDate.getDate() < 10 ? '0' + nowDate.getDate() : nowDate.getDate()
        // let hour = nowDate.getHours() < 10 ? '0' + nowDate.getHours() : nowDate.getHours()
        // let minute = nowDate.getMinutes() < 10 ? '0' + nowDate.getMinutes() : nowDate.getMinutes()
        // let second = nowDate.getSeconds() < 10 ? '0' + nowDate.getSeconds() : nowDate.getSeconds()
        this.timeValue[0] = year + '-' + month + '-01'
        this.timeValue[1] = year + '-' + month + '-' + date
        this.getPage()
      },
      changeTimeValue () {
        this.pageNum = 1
        this.pageSize = 10
        this.getPage()
      },
      getPage () {
        let reqData = this.requestData
        reqData.pageNum = this.pageNum
        reqData.pageSize = this.pageSize
        if (this.timeValue.length > 0) {
          reqData.startTime = `${this.timeValue[0]} 00:00:00`
          reqData.endTime = `${this.timeValue[1]} 23:59:59`
        }
        this.$axios.post(api.getRoomRecordPage, reqData)
          .then(res => {
            let list = res.data.data.list
            this.total = res.data.data.total
            list.map(v => {
              v.picUrl = v.personPic
              if (v.fitment === '0') {
                v.fitmentText = '精装'
              } else if (v.fitment === '1') {
                v.fitmentText = '简装'
              } else if (v.fitment === '2') {
                v.fitmentText = '毛坯'
              } else {
                v.fitmentText = '--'
              }
            })
            this.tableData = list
          })
          .catch(errorHandler('获取失败'))
      },
      searchKey (v) {
        this.pageNum = 1
        this.requestData.searchKey = v
        this.getPage()
      },
      changePagination (data) {
        this.pageNum = data[0]
        this.pageSize = data[1]
        this.getPage()
      },
      changeSelection (codeArr) {
        this.selectionArr = codeArr
      },
      deleteSelection () {
        if (this.selectionArr.length === 0) {
          nAlert('请先选择需要删除的记录')
          return false
        } else {
          this.$confirm('是否确认删除所选中的记录？', '提示')
            .then(() => {
              this.deleteLine(this.selectionArr)
            })
            .catch(() => {
              console.log('取消删除')
            })
        }
      },
      deleteLine (code) {
        this.$axios.post(api.deleteRoomRecord, code)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('删除成功')
              this.selectionArr = []
              this.getPage()
            }
          })
          .catch(errorHandler('删除失败'))
      },



    },
    watch: {}
  }
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>

<style lang="less">
  .appointment_main {
    .el-dialog .el-dialog__body .el-table .has-gutter th:first-child {
      /*width: 50%!important;*/
    }

    .right-slide-enter,
    .right-slide-leave-active {
      transform: translateX(100%);
    }

    .right-slide-leave-active,
    .right-slide-enter-active {
      transition: all 0.3s;
    }
    .window-left-box {
      position: fixed;
      right: 0;
      top: 0;
      bottom: 0;
      width: 60%;
      z-index: 10;
    }
    .window-left-box .move-enter-active, .window-left-box .move-leave-active {
      transition: all 2s linear;
      transform: translate3d(0, 0, 0);
    }
    .window-left-box .move-enter, .window-left-box .move-leave {
      transform: translate3d(100%, 0, 0);
    }
    .window-left-main {
      width: 100%;
      height: 100%;
      z-index: 30;
      background: #FFFFFF;
      padding: 5px 10px;
      overflow: auto;
    }

    .mask {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      opacity: .4;
      z-index: -1;
      background-color: #000000;
      transition: opacity .5s ease;
    }

    form {
      width: 450px;
      margin: 0 auto;
      text-align: left;
    }
    .form-line {
      margin: 25px 0;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .line-text{
      color: #48576a;
      font-size: 14px;
      margin-right: 10px;
      width: 100px;
      display: flex;
      justify-content: space-between;
    }
    .line-info {
      width: 220px;
    }
    .form-btn-box {
      width: 530px;
      padding: 0 124px;
      margin: 40px auto 0;
      display: flex;
      justify-content: space-between;
    }

    .person-management-drawer {
      .el-icon-back {
        margin: 20px 20px 10px;
        display: block;
        border: 0;
        font-size: 20px;
        background-color: #ffffff;
        cursor: pointer;
      }
      .el-icon-back:hover {
        color: #00a0e6;
      }
      .all-table-class .el-table td {
        padding: 10px 0;
      }
      form {
        position: relative;
        .drawerPersonImg {
          position: absolute;
          right: 0;
          top: 0;
          width: 120px;
        }
        .noDrawerPersonImg {
          position: absolute;
          right: 0;
          top: 0;
          width: 120px;
          height: 150px;
          line-height: 160px;
          border: 1px dashed #dcdfe6;
          text-align: center;
          color: #999999;
        }
      }
    }
    .drawerBtnBox {
      width: 360px;
      padding-right: 60px;
      margin: 0 auto;
      .btn-confirm {
        border: 0;
        color: #FFF;
        padding: 8px 16px;
        background-color: #00a0e6;
        border-radius: 4px;
        margin-right: 60px;
      }
      .btn-confirm:hover {
        color: #FFF;
        background-color: #06b3ff;
      }
      .reject-button {
        border: 0;
        background-color: #f25721;
        color: #FFFFFF;
        border-radius: 4px;
      }
      .reject-button:hover {
        background-color: #F96E3D;
      }
    }
  }

  .el-dialog__body {
    .el-table .cell{
      text-align: center;
    }
    .el-table th>.cell {
      color: #48576a;
      font-weight: bold;
    }
  }
  .el-dialog {
    .el-dialog .el-dialog__body .el-table__empty-block {
      margin: 0 auto;
    }
    .el-table__empty-text {
      width: auto;
    }
    .el-dialog__header {
      text-align: center
    }
    .el-dialog__body {
      .el-table th:first-child {
        width: auto!important;
      }
    }
  }
  .btn-box {
    .el-date-editor .el-range-separator {
      padding: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/Agent/agentShowing/agentShowing.vue